<yasc-dialog
        headerKey="reportBug"
        style="min-width: 60vw;overflow: hidden; grid-template-rows: auto 1fr auto"
        (cancelClicked)="dialogRef.close()"
        [disableSave]="!this.form.valid"
        saveButtonName="generalCreate"
        (saveClicked)="dialogRef.close(this.bugReq)">

    <yasc-input-field
            [(yascModel)]="bugReq.title"
            [yascFormGroup]="form"
            [yascFormControlName]="'title'"
            [yascRequired]="true"
            [yascPlaceholder]="('helpTextBugTitle'|translate:locale.language)!"
            [yascLabel]="('generalTitle'|translate:locale.language)!">
    </yasc-input-field>


    <yasc-input-field
            [(yascModel)]="bugReq.route"
            [yascFormGroup]="form"
            [yascFormControlName]="'route'"
            [yascRequired]="true"
            [yascPlaceholder]="('helpTextFrontendRoute'|translate:locale.language)!"
            [yascLabel]="('generalRoute'|translate:locale.language)!">
    </yasc-input-field>

    <yasc-combobox
            [yascLabel]="('generalType' | translate: locale.language)!"
            [yascOptions]="ticketTypes | enumConvert: this.translation"
            [yascFormGroup]="form"
            [yascFormControlName]="'bugType'"
            [yascRequired]="true"
            [yascPlaceholder]="('helpTextTicketType'|translate:locale.language)!"
            [(yascModel)]="bugReq.ticketType">
    </yasc-combobox>

    <yasc-text-area
            [yascLabel]="('generalDescription'|translate:locale.language)!"
            [(yascModel)]="bugReq.description!"
            [yascFormGroup]="form"
            [yascFormControlName]="'description'"
            [yascMinRows]="5"
            [yascRequired]="true"
            [yascPlaceholder]="('helpTextDescription'|translate:locale.language)!"
            [yascMaxLength]="2000">
    </yasc-text-area>
    <!-- TODO: YML-57 -->


    <h3>{{ ('stepsToReproduce'|translate:locale.language)! }}</h3>
    <div style="display: flex;justify-content: space-between; align-items: baseline">
        <yasc-input-field
                style="width: 90%"
                [(yascModel)]="newStepValue"
                [yascFormGroup]="form"
                [yascFormControlName]="'newStep'"
                [yascRequired]="false"
                [yascPlaceholder]="('helpTextStepToReproduce'|translate:locale.language)!"
                [yascLabel]="('stepToReproduceNr'|translate:locale.language: {stepNo: this.bugReq.stepsToReproduce.length+1})!">
        </yasc-input-field>
        <button mat-mini-fab (click)="addStep()" style="margin-right: 1rem">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <ul>
        <li *ngFor="let step of bugReq.stepsToReproduce">
            <div style="display: flex;justify-content: space-between;padding: 0 5rem 0 0; color:black">
                {{ step }}
                <mat-icon (click)="removeStep(step)" style="cursor: pointer">cancel</mat-icon>
            </div>
        </li>
    </ul>

    <h3>{{ ('addAttachments'|translate:locale.language)! }}</h3>

    <yasc-file-upload style="padding-top: 0.5rem"
                      [yascAllowMultiUpload]="true"
                      [yascType]="mediaTypes.Screenshot"
                      [yascPasteScope]="'document'"
                      [(files)]="this.bugReq.attachments"
                      [yascShowUploadProgress]="false">
    </yasc-file-upload>

</yasc-dialog>